.ajaxContainer {
  margin: 0;
  overflow: hidden;
  height: 0;
  transition: height 0.3s;
  &.open {
    height: var(--openHeight);
  }
  .container-xxl {
    padding-inline: 0 !important;
  }
}

.loading {
  lg-icon {
    font-size: 3rem;
    line-height: 1;
    @media (prefers-reduced-motion: no-preference) {
      svg {
        animation: rotate 1s linear infinite;
      }
    }
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
